'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Container } from '@src/components/Container/Container';
import { Stamp } from '@src/components/TopNavV5/Stamp';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { TopNavV5DesktopSubMenu } from '@src/components/TopNavV5/TopNavV5Desktop/TopNavV5DesktopSubMenu';
import { cn } from '@src/utils/tailwind';
export const TopNavV5DesktopSlidingPanel = () => {
  const $ = _c(22);
  const {
    setExpanded,
    setLeftMenuIndex,
    leftMenuIndex,
    expandedMenu,
    isExpanded,
    topNavDesktopTopOffset
  } = useTopNavV5();
  let t0;
  if ($[0] !== expandedMenu?.leftMenuItems || $[1] !== expandedMenu?.subMenuType || $[2] !== leftMenuIndex || $[3] !== setLeftMenuIndex) {
    t0 = () => {
      if (expandedMenu?.subMenuType === "subMenu") {
        return <TopNavV5DesktopSubMenu />;
      }
      if (expandedMenu?.subMenuType === "leftMenu") {
        return <div className="grid grid-cols-5 gap-10"><div className="col-span-1 border-r border-white/10 pr-5"><div className="flex flex-col gap-3">{expandedMenu?.leftMenuItems?.map((item, index) => <button onClick={() => setLeftMenuIndex(index)} key={index} className={cn("flex items-center justify-between text-body-base font-medium")}><div className="flex items-center gap-2"><div className={cn("text-bodi-gray-butters", {
                    "text-bodi-white underline": leftMenuIndex === index
                  })}>{item.title}</div><Stamp text={item.stamp} /></div><ChevronRightIcon className={cn("size-5 text-bodi-gray-medium transition-colors", {
                  "text-bodi-accent-bright-500": leftMenuIndex === index
                })} /></button>)}</div></div><div className="col-span-4"><TopNavV5DesktopSubMenu /></div></div>;
      }
    };
    $[0] = expandedMenu?.leftMenuItems;
    $[1] = expandedMenu?.subMenuType;
    $[2] = leftMenuIndex;
    $[3] = setLeftMenuIndex;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const renderContent = t0;
  let t1;
  if ($[5] !== setExpanded) {
    t1 = () => setExpanded(false);
    $[5] = setExpanded;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = !isExpanded;
  let t3;
  if ($[7] !== isExpanded || $[8] !== t2) {
    t3 = cn("fixed top-(--offset-top) left-0 z-40 w-full border-t border-bodi-gray-dark bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 py-6 text-white transition-all duration-200", {
      "translate-y-0": isExpanded,
      "translate-y-[calc(-100%-var(--offset-top))]": t2
    });
    $[7] = isExpanded;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = `${topNavDesktopTopOffset}px`;
  let t5;
  if ($[10] !== t4) {
    t5 = {
      "--offset-top": t4
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== renderContent) {
    t6 = renderContent();
    $[12] = renderContent;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <Container>{t6}</Container>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t5 || $[19] !== t7 || $[20] !== topNavDesktopTopOffset) {
    t8 = <div onMouseLeave={t1} data-offset-top={topNavDesktopTopOffset} className={t3} style={t5}>{t7}</div>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = topNavDesktopTopOffset;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};